module.exports = __webpack_public_path__ + "ffe5a30c2f953cd61ee73a355b180dcd.pdf";